/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileName: NonNullable<unknown> }} Unsupportedimagefileskipped3Inputs */

const en_unsupportedimagefileskipped3 = /** @type {(inputs: Unsupportedimagefileskipped3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fileName} was skipped - only JPEG, PNG and WebP images are supported.`)
};

const de_unsupportedimagefileskipped3 = /** @type {(inputs: Unsupportedimagefileskipped3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fileName} wurde übersprungen – nur JPEG-, PNG- und WebP-Bilder werden unterstützt.`)
};

/**
* | output |
* | --- |
* | "{fileName} was skipped - only JPEG, PNG and WebP images are supported." |
*
* @param {Unsupportedimagefileskipped3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unsupportedimagefileskipped3 = /** @type {((inputs: Unsupportedimagefileskipped3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsupportedimagefileskipped3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unsupportedimagefileskipped3(inputs)
	return de_unsupportedimagefileskipped3(inputs)
});
export { unsupportedimagefileskipped3 as "unsupportedImageFileSkipped" }